export const LOAD_REQUESTED = "EXECUTIVE_APPROVAL/LOAD_REQUESTED";
export const LOAD_SUCCESS = "EXECUTIVE_APPROVAL/LOAD_SUCCESS";
export const LOAD_FAIL = "EXECUTIVE_APPROVAL/LOAD_FAIL";

// eslint-disable-next-line no-unused-vars
export default (state = {}, { type, data }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadExecutiveApproval = data => ({ type: LOAD_REQUESTED, data });
export const successLoadExecutiveApproval = data => ({ type: LOAD_SUCCESS, data });
export const failLoadExecutiveApproval = data => ({ type: LOAD_FAIL, data });
